import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import axios from 'axios';
import PageWrapper from '@/components/SupportSection/shared/PageWrapper';
import SupportContactUs from '@/components/SupportSection/SupportContactUs';
import { WordPressAPI } from '@/config';

const PullUpScheduler = dynamic(
  () => import("@components/PullUpScheduler/PullUpSchedulerV2"),
  { ssr: false }
);

const ContactUsSupport = ({ data }) => {
  const {
    additional_questions,
    lead_values,
    paid_campaign,
  } = data;

  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const toggleScheduler = () => {
    setIsSchedulerOpen(!isSchedulerOpen);
  }

  return (
    <PageWrapper data={data} noPadding={true}>
      <SupportContactUs data={data} toggleScheduler={toggleScheduler} />
      {isSchedulerOpen && (
        <PullUpScheduler
          setIsSchedulerOpen={setIsSchedulerOpen}
          AdditionalQuestions={additional_questions}
          leadValues={lead_values}
          PaidCampaign={paid_campaign}
        />
      )}
    </PageWrapper>
  );
}



export const getStaticProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/20479`);

  return {
    props: {
      data: data.acf,
      pageTitle: 'Contact Us',
    },
    // revalidate: 1,
  };
};

ContactUsSupport.propTypes = {
  data: PropTypes.object,
  pageTitle: PropTypes.string,
};

export default ContactUsSupport;